module.exports = __webpack_public_path__ + "img/logo_taxa_pod.1e3e546e.svg";